<template>
  <div>
    <v-checkbox
      id="gdpr"
      @change="toggleValue"
      :error-messages="errorMessage"
    >
      <template #label>
        <div class="small-text">
          Съгласявам се с
          <a
            href="/terms-and-conditions"
            target="_blank"
            @click.stop
          >
            Общите условия
          </a>
          на услугата,
          <a
            href="/privacy-policy"
            target="_blank"
            @click.stop
          >
            Политиката за поверителност,
          </a>
          <a
            href="/cookies"
            target="_blank"
            @click.stop
          >
            Политиката за използване на cookies,
          </a>
          <a
            href="/customer-service-policies"
            target="_blank"
            @click.stop
          >
            Политиката за работа с клиенти
          </a>
          и декларирам, че съм на възраст над 18 години, че съм се запознал с
          подробното описание на събитието, пропускателния режим и възрастовите
          ограничения за събитието.
        </div>
      </template>
    </v-checkbox>
  </div>
</template>

<script>
export default {
  name: 'TosCheckbox',
  props: {
    isValid: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    errorMessage() {
      return !this.isValid && !this.isSelected
        ? 'Трябва да се съгласите с общите условия'
        : ''
    },
  },
  data() {
    return {
      isSelected: false,
    }
  },
  methods: {
    toggleValue(v) {
      this.isSelected = v
      this.$emit('update-gdpr', v)
    },
  },
}
</script>

<style scoped>
/deep/ .error--text .v-input__slot {
  border: 1px solid #ff335a;
  border-radius: 4px;
  background: #fff3f3;
  padding: 5px;
}
</style>
